<template>
    <div>
        <h2>Add T&E Code</h2>
        <time-expense-form :is-unbound="false" :is-marketing="false"></time-expense-form>
    </div>
</template>

<script>
    import Vue from "vue";
    import MainForm from "./entry-form/main-form.vue";

    Vue.component("time-expense-form", MainForm);

    export default {
        props: {
            action: String
        },
        created() {
            this.$store.state.editId = 0;
            this.$store.state.activityCode = "";

            if (this.action === 'continue') {
                this.$store.state.reviveSession = true;
            } else {
                this.$store.state.defaultUser = this.$store.state.currentUser;
            }
            $(".nav-category-te").removeClass('currentpage');
            $(".nav-item-new-te").addClass('currentpage');
        },
    };
</script>
